import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary.ts';

import { useSetupConnector } from '../hooks/useSetupConnector.ts';

import { SetupConnectorModal } from './SetupConnectorModal.tsx';

/**
 * Single host for the connector setup modal. Render this once so the modal can
 * be shown for users in the experiment, gated on a no-exposure experiment check
 * (`UNSAFE_expValNoExposure('twcg-1489-cc-3p-connector-onboarding', 'isEnabled', false)`)
 * so this always-mounted host does not fire a page-wide experiment exposure.
 */
export function ConnectorSetupModalHost(): React.JSX.Element | null {
	const { activeConnectorKey, closeModal } = useSetupConnector();

	if (!activeConnectorKey) {
		return null;
	}

	return (
		<TransparentErrorBoundary attribution={Attribution.GROWTH_CFIND}>
			<SetupConnectorModal connectorKey={activeConnectorKey} onClose={closeModal} />
		</TransparentErrorBoundary>
	);
}
